import { nodeComponentRegistry } from '../../../r3f/NodeComponentRegistry';
import { WorldEnvironment } from './Component';
nodeComponentRegistry.register({ typeName: 'WorldEnvironment', Component: WorldEnvironment });
//# sourceMappingURL=index.r3f.js.map